import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initGoogleAnalytics } from "./hooks/useGoogleAnalytics";

// Única inicialización de GA4 para toda la app: se ejecuta una sola vez,
// de forma síncrona, antes de montar React (no hay index.html editable
// en este proyecto, así que este es el punto de entrada real).
initGoogleAnalytics();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-873" data-mp="2f9p71fz14pax" />);
}